
import axios from "axios";
import { UserData } from "components/Sidebar/Sidebar_Principal";
import { ResponseRequest } from "components/Types/GeneralTypes";
import { alertService } from "components/Varios/alert_service";
import config from "config.json"
import { authHeaderWithToken, authHeaderWithUserData } from "helpers/auth-header";
import { authenticationService } from "services/authentication.service";

import { NotificacionesEmbarazoTh } from "./TypesNotificacionEmbarazoTh";
import { handle_error } from "components/DirectivoUnidad/Vacaciones/helper_function";

import Swal from "sweetalert2";
import ExitoSVG from "./../../../assets/icons/Permisos/Exitosa.svg"
import ErrorSVG from "./../../../assets/icons/Permisos/Error.svg"

async function showAlert(message, imageSrc, isSuccess) {
    Swal.fire({
        text: message,
        imageUrl: `${imageSrc}`,
        imageHeight: 100,
        imageAlt: isSuccess ? "Éxito" : "Error",
        confirmButtonText: "Entendido",
        confirmButtonColor: "#243165",
    });
}

export async function ObtenerInformacionNotificacionesEmbarazo() {
    const URL = config.SERVER_URL + "AprobacionTh/NotificacionEmbarazo";

    const datosUsuario: UserData = authenticationService.currentUserValue;
    var resultado: ResponseRequest = { status: -1 }
    try {
        const respuesta = await axios.get(URL,
            {
                headers: authHeaderWithUserData(datosUsuario)
            })
        const datos: NotificacionesEmbarazoTh[] | string = respuesta.data;

        if (typeof (datos) === "string") {
            resultado = { status: respuesta.status, dataResponse: datos }
        }
        else {
            const datosMapeados: NotificacionesEmbarazoTh[] = MapearSolicitudesNotificacionEmbarazo(datos)
            resultado = { status: respuesta.status, dataResponse: datosMapeados }
        }
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            resultado = { status: error.response.status, errorMessage: error.response.data }
        }

    }
    return resultado;
}

export function MapearSolicitudesNotificacionEmbarazo(datos: NotificacionesEmbarazoTh[]) {
    const datosMapeados: NotificacionesEmbarazoTh[] = datos.map((val, ind) => {
        return {
            ...val,
        }
    })
    return datosMapeados
}


export async function InactivarNotificacionEmbarazo(idSolicitud: number) {
    const infoUsuario: UserData = authenticationService.currentUserValue;

    const URL = config.SERVER_URL + "AprobacionTh/InactivarNotificacionEmbarazo/" + idSolicitud;
    try {
        const respuesta = await axios.post(URL, {},
            {
                headers: authHeaderWithToken(infoUsuario.token),
            }
        )
        //alertService.success("Se ha registrado la interrupción de embarazo de la servidora");
        await showAlert("Se ha registrado la interrupción de embarazo de la servidora", ExitoSVG, true)
        return 1;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            await showAlert(error.response.data, ErrorSVG, false)
        }
        return -1;
    }
}

export async function downloadExcelReportEmbarazo() {
    var currentUser: UserData = authenticationService.currentUserValue;
    if (!currentUser) { return -1 }

    await fetch(config.SERVER_URL + "AprobacionTh/NotificacionEmbarazo/Reporte", {
        headers: {
            'Content-Type': 'application/json',
            Authorization: `KEYESPOL ${currentUser?.token}`
        },
    })
        .then(response => {
            response.blob().then(blob => {
                let url = window.URL.createObjectURL(blob);
                let a = document.createElement('a');
                a.href = url;
                a.download = "Reporte Embarazadas"
                a.click();
            });
        })
        .catch((error) => {
            var error_any: any = error;
            var status_code: number = handle_error(error_any);
            switch (status_code) {
                case 0 || -1:
                    alertService.error("No se ha podido establecer contacto con el servidor");
                    break;
                case 500:
                    alertService.error("Ha ocurrido un error inesperado");
                    break;
                default:
                    alertService.error("Ha ocurrido un error desconocido");
                    break;
            }

            window.scrollTo({
                top: 0,
                behavior: "auto"
            });
            return -1
        });
    return 1



}